// extracted by mini-css-extract-plugin
export var arrowButton = "Slideshow-module--arrow-button--a223e";
export var arrowButtonLeft = "Slideshow-module--arrow-button-left--16af0";
export var arrowButtonRight = "Slideshow-module--arrow-button-right--5dc6e";
export var buttonFullscreen = "Slideshow-module--button-fullscreen--4ec37";
export var buttonFullscreenClose = "Slideshow-module--button-fullscreen-close--11b72";
export var fluidHeight = "Slideshow-module--fluid-height--bbbcc";
export var fullscreenInlineVideoPlayer = "Slideshow-module--fullscreen-inline-video-player--103f8";
export var icon = "Slideshow-module--icon--819b4";
export var imageCaption = "Slideshow-module--image-caption--d8caa";
export var imageCaptionInside = "Slideshow-module--image-caption-inside--e6d12";
export var imageFitContain = "Slideshow-module--image-fit-contain--8123d";
export var imageFitCover = "Slideshow-module--image-fit-cover--c3353";
export var imageGalleryThumbnailInner = "Slideshow-module--image-gallery-thumbnail-inner--fd27a";
export var inlineVideoPlayer = "Slideshow-module--inline-video-player--8aa25";
export var inlineVideoPlayerContainer = "Slideshow-module--inline-video-player-container--9943a";
export var playVideoButton = "Slideshow-module--play-video-button--79ec9";
export var roundedCorners = "Slideshow-module--roundedCorners--bed33";
export var slideshow = "Slideshow-module--slideshow--5656c";
export var slideshowFullscreen = "Slideshow-module--slideshow-fullscreen--eb141";
export var slideshowHideCaption = "Slideshow-module--slideshow-hide-caption--4feca";
export var slideshowHideNavigation = "Slideshow-module--slideshow-hide-navigation--65702";
export var slideshowVideoItem = "Slideshow-module--slideshow-video-item--7de65";
export var thumbnailVideoIcon = "Slideshow-module--thumbnail-video-icon--fe79f";
export var variantDark = "Slideshow-module--variant-dark--aed51";
export var variantGray = "Slideshow-module--variant-gray--89870";
export var videoIcon = "Slideshow-module--video-icon--437c1";